/** @type {import('@vue/compat').ComponentOptions} */
export default {
  data: {
    data: [],
    user: [],
    time: {
      hour: '00',
      minute: '00',
      second: '00',
      millisecond: '000',
    },
    countdownInterval: null,
  },
  mounted() {
    this.getVipInfo();
    this.countTime();
  },
  methods: {
    calculateMinDiscount(data) {
      if (!Array.isArray(data)) return [];
      data.forEach((item) => {
        const vipGroup = Array.isArray(item.vip_group) ? item.vip_group : [];
        item.vip_group = vipGroup;
        let minPrice = Infinity;
        let minPriceElement = null;
        vipGroup.forEach((element) => {
          const discountedPrice = (element.price * element.discount) / 100;
          if (discountedPrice < minPrice) {
            minPrice = discountedPrice;
            minPriceElement = element;
          }
        });
        item.vip = minPriceElement;
      });
      return data;
    },
    getVipInfo() {
      this.$http.post(`${qk_rest_url}getVipInfo`).then((res) => {
        this.data = this.calculateMinDiscount(res.data.data || []);
        this.user = res.data.user_data || null;
      }).catch((err) => {
        qkShowApiError(err, '加载VIP信息失败');
      });
    },
    vipPay(index) {
      this.$createModal('vip', {
        size: 720,
        open: (ev) => {
          ev.$refs.component.$data.index = index;
        },
      });
    },
    countTime() {
      const endTime = new Date((new Date()).setHours(23, 59, 59, 999)).getTime();
      if (new Date().getTime() > endTime) return;

      const updateCountdown = () => {
        const remainingTime = endTime - new Date().getTime();
        if (remainingTime <= 0) {
          clearInterval(this.countdownInterval);
          return;
        }
        this.time.hour = Math.floor(remainingTime / (1000 * 60 * 60));
        this.time.minute = this.prefixZero(Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60)));
        this.time.second = this.prefixZero(Math.floor((remainingTime % (1000 * 60)) / 1000));
        this.time.millisecond = this.prefixZero(Math.floor((remainingTime % 1000) / 1));
      };

      this.countdownInterval = setInterval(updateCountdown, 10);
    },
    prefixZero(number) {
      return number > 9 ? number : `0${number}`;
    },
  },
};
